import { action, computed, observable } from 'src_common/common/mobx-wrapper';
import { ChangeEvent } from 'react';
import { SingleTagType } from 'src/AppState/sdk/staff';
import {
    MarketTemplateSettingsFormState,
    UpdateTemplateBody,
} from 'src/components/MarketTemplateSettingsForm/MarketTemplateSettingsForm.state';
import { SelectionType } from 'src/components/MarketTemplateSettingsForm/Components/MarketTemplateSelectionSettings';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import { SportMarketTemplatesState } from 'src/components/SportPopup/SportMarketTemplates/SportMarketTemplates.state';
import { makeAutoObservable } from 'mobx';

type TagDetails = SingleTagType[1];
export class MarketTemplateSelectionState {
    @observable openedSelections: Array<string> = [];
    readonly inputState: FormInputState<string, string>;

    constructor(
        readonly selection: SelectionType,
        readonly marketTemplateSettingsFormState: MarketTemplateSettingsFormState,
        readonly marketTemplateState: SportMarketTemplatesState
    ) {
        this.inputState = FormInputState.new(selection.name);
        makeAutoObservable(this);
    }
    @action toggleSelection = (): void => {
        this.openedSelections.includes(this.selection.id) === false
            ? this.openedSelections.push(this.selection.id)
            : (this.openedSelections = this.openedSelections.filter((id) => id !== this.selection.id));
    };

    onChangeAutoCreate = (data: UpdateTemplateBody): void => {
        this.marketTemplateSettingsFormState.onChangeSelections(data, this.selection);
    };

    onSelectionNameChange = (e: ChangeEvent<HTMLInputElement>): void => {
        this.inputState.setValue(e.target.value);
        this.marketTemplateSettingsFormState.onChangeSelections({ name: e.target.value }, this.selection);
    };

    onEditName = (e: ChangeEvent<HTMLInputElement>): void => {
        this.inputState.setValue(e.target.value);
    };

    onTagChange = (value: string, target: string): void => {
        this.marketTemplateSettingsFormState.onChangeSelections(
            {
                tags: {
                    ...this.selection.tags,
                    [target]: value,
                },
            },
            this.selection
        );
    };

    @computed get tagsForSelections(): Array<Record<string, TagDetails>> {
        const out: Array<Record<string, TagDetails>> = [];
        const tags = this.marketTemplateState.getTags;
        if (this.marketTemplateState.getTags !== 'loading') {
            const filtered = Object.entries(tags).filter((item) => item[1].applicableTo.includes('selection-template'));
            filtered.forEach((item) => {
                out.push({ [item[0]]: item[1] });
            });
        }
        return out;
    }
}
